let goodsData = [{
	"id": 1000271,
	"name": "智能锁管理平台",
	"name_title": "web服务器，综合性管理平台",
	"model": "v1.2",
	"sku_info": [{
		"sku_id": 1000271,
		"ali_image": require('@/assets/img/products/software/platform/home.jpg'),
		"spec_json": {
			"show_name": "地图显示"
		}
	}, {
		"sku_id": 1000271,
		"ali_image": require('@/assets/img/products/software/platform/platform-home1.png'),
		"spec_json": {
			"show_name": "实时输出"
		}
	}, {
		"sku_id": 1000271,
		"ali_image": require('@/assets/img/products/software/platform/platform-openrecord.png'),
		"spec_json": {
			"show_name": "开锁记录"
		}
	}]
}, {
	"id": 1000299,
	"name": "微信小程序",
	"name_title": "跨平台应用，管理蓝牙钥匙,上传开锁记录",
	"model": 'v1.0.2',
	"sku_info": [{
		"sku_id": 1000299,
		"ali_image": require('@/assets/img/products/software/wxMini/home.jpg'),
		"spec_json": {
			"show_name": "主页面"
		}
	}, {
		"sku_id": 1000299,
		"ali_image": require('@/assets/img/products/software/wxMini/open_record.jpg'),
		"spec_json": {
			"show_name": "开锁记录"
		}
	}]
}, {
	"id": 1000300,
	"name": "手机APP",
	"name_title": "管理蓝牙钥匙,上传开锁记录",
	"model": 'v1.3',
	"sku_info": [{
			"sku_id": 1000300,
			"ali_image": require("@/assets/img/products/software/app/authkey.jpg"),
			"spec_json": {
				"show_name": "授权管理"
			}
		},
		{
			"sku_id": 1000300,
			"ali_image": require("@/assets/img/products/software/app/authhistory.jpg"),
			"spec_json": {
				"show_name": "开锁记录"
			}
		}
	]
}, {
	"id": 1000302,
	"name": "微信公众号",
	"name_title": "实时接收授权记录、开锁记录",
	"model": 'v1.0',
	"sku_info": [{
		"sku_id": 1000302,
		"ali_image": require("@/assets/img/products/software/gongzonghao/openrecord.jpg"),
		"spec_json": {
			"show_name": "推送记录"
		}
	}]
}]

export default goodsData


// WEBPACK FOOTER //
// ./src/lib/softwaresData.js